import '../style.scss'
import { useEffect, useState } from "react"
import { FiChevronDown } from "react-icons/fi"
import { RiCloseFill } from "react-icons/ri"
import { AbsoluteContainer, AppLabel, Button, CustomContainer, FixedContainer, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, SidePopupContainer } from "src/style"
import { VscSmiley } from 'react-icons/vsc'
import { IoDocumentTextOutline, IoImageOutline } from 'react-icons/io5'
import { ImAttachment } from 'react-icons/im'


export const SendMessage: React.FC<any> = ({close}) => {
    const [input, setInput] = useState({serviceType: ''})
    
    useEffect(() => {
        document.body.style.overflow = 'hidden'

        return () => { document.body.style.overflow = 'auto' }
    }, [])
    
    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FixedContainer 
                className="service-request-container" 
                zIndex="9" radius="0.8" bgColor="#ffffff"
                topPadding="1.5" width='71.5' height="75" hUnit='%'
            >
                <Form style={{height: '100%'}}>
                    <CustomContainer 
                        height="85" hUnit="%" padding="2.5" overflow="auto" topPadding="1"
                    >
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel textSize="2" fontWeight="600">Message to Ridwan Kolawole</AppLabel>
                            <AbsoluteContainer top="0" right="0" onClick={close}>
                                <RiCloseFill className='close-icon' />
                            </AbsoluteContainer>
                        </FlexRow>
                        <FormGroup bottomMargin="1.5">
                            <label>Email</label>
                            <input 
                                placeholder='Enter email'
                                name='email'
                            />
                        </FormGroup>
                        <FormGroup bottomMargin="1.5">
                            <label>Subject</label>
                            <input 
                                placeholder='Enter Subject'
                                name='subject'
                            />
                        </FormGroup>
                        <FormGroupWithIcon bottomMargin='1.5'>
                            <label>Agent</label>
                            <div className="input-with-icon">
                                <select 
                                    name="serviceType" 
                                    style={{color: input.serviceType ? '#494949' : '#999'}}
                                    //required
                                >
                                    <option value="">Select name</option>
                                    <option value='Male'>Ridwan Kolawole</option>
                                    <option value='Female'>Chijindu Amadi</option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon bottomMargin='1.5'>
                            <label>Priority</label>
                            <div className="input-with-icon">
                                <select 
                                    name="serviceType" 
                                    style={{color: input.serviceType ? '#494949' : '#999'}}
                                    //required
                                >
                                    <option value="">Select priority</option>
                                    <option value='Male'>Low</option>
                                    <option value='Female'>Medium</option>
                                    <option value='Female'>High</option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FormGroup bottomMargin="0">
                            <label>Message</label>
                            <CustomContainer 
                                height="16.3" radius="0.6" bgColor="#EDF2F7"
                                padding="1.5"
                            >
                                <textarea className="custom-textarea" />
                                <AbsoluteContainer bottom="0" left="0" width="100" sizeUnit="%">
                                    <FlexRow width="auto" sizeUnit="" gap="2" padding='1.5' bottomPadding='1'>
                                        <VscSmiley className="chat-input-icons" />
                                        <IoImageOutline className="chat-input-icons" />
                                        <ImAttachment className="chat-input-icons" />
                                        <IoDocumentTextOutline className="chat-input-icons" />
                                    </FlexRow>
                                </AbsoluteContainer>
                            </CustomContainer>
                        </FormGroup>
                    </CustomContainer>
                    <FlexColumn height="15" hUnit="%" justifyContent="flex-end">
                        <FlexRow justifyContent="flex-end" padding="2.5">
                            <Button
                                    width='8.1' borderColor='#E4ECF7' height='3.6'
                                    hoverBgColor='#E4ECF7' hoverColor='#505780'
                                    bgColor="#ffffff" color="#505780" rightMargin="1"
                                    radius="0.6" titleSize="1.2"
                                    onClick={close}
                                >
                                Cancel
                            </Button>
                            <Button
                                width='12.6' borderColor='#4C6FFF' height='3.6'
                                hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                radius="0.6" titleSize="1.2"
                            >
                                Send message
                            </Button>
                        </FlexRow>
                    </FlexColumn>
                </Form>
            </FixedContainer>
        </>
    )
}